import axios from 'axios';
import { getConfig } from '../../reducers/portalConfig';
import { RESET_PASSWORD_REQUEST, RESET_PASSWORD_SUCCESS, RESET_PASSWORD_ERROR } from '../../constants';

export const resetPassword = (payload) => async (dispatch, getState) => {
  const config = getConfig(getState());
  const { portal } = config;
  const url = `${portal?.hostname}/api/${portal.tenantPrefix}/reset-my-password`;

  dispatch({ type: RESET_PASSWORD_REQUEST })

  await axios.put(url, payload, { credentials: 'include' })
    .then((response) => {
      if (response.status === 201 || response.status === 200) {
        dispatch({ type: RESET_PASSWORD_SUCCESS, payload: response.data });
      }
    })
    .catch((error) => {
      const response = error?.response || {};
      const errorData = response.data?.error || {}
      
      if (errorData.detail?.userErrorMessage) {
        dispatch({ type: RESET_PASSWORD_ERROR, payload: errorData.detail?.userErrorMessage || '' });
        return;
      }

      if (errorData.detail?.errorCode) {
        const errorCode = errorData.detail?.errorCode;
        dispatch({ type: RESET_PASSWORD_ERROR, payload: { errorCode } });
        return;
      }

      dispatch({ type: RESET_PASSWORD_ERROR, payload: '' })
    });
};